// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { ellipsis } from "@mcmc/XDL/Utilities";
import parse from "html-react-parser";
import React from "react";
import styled, { css, ThemeProps, withTheme } from "styled-components";

interface Props extends TypographyProps {
    content: string;
    maxLines: number;
}

type MultilineEllipsisProps = Props & ThemeProps<BaseTheme>;

export const MultiLineText = styled(Typography as any)<{ maxLines: number; lineHeight: number }>`
    ${({ maxLines, lineHeight }) => ellipsis(maxLines, parseInt(lineHeight, 10))};
`;

const MultilineEllipsis: React.FC<MultilineEllipsisProps> = ({ content, ...otherProps }) => {
    return <MultiLineText {...otherProps}>{parse(content, parserOptions)}</MultiLineText>;
};

export default withTheme(MultilineEllipsis);
